import { motion } from 'framer-motion';
import React from 'react';
import { useSteps } from '../../contexts/stepContext';
import {
  ArrowRight,
  UploadIcon,
  CheckIcon,
  Container,
  ErrorIcon,
  InstrctionsIcon,
  StepItem,
  UserIcon,
} from './styles';

const Steps = (): React.ReactElement => {
  const { currentStep } = useSteps();
  const steps = [1, 2, 3, 4];

  const multIcons = (icon: number) => {
    switch (icon) {
      case 1:
        return <UserIcon />;
      case 2:
        return <InstrctionsIcon />;
      case 3:
        return <UploadIcon />;
      case 4:
        return <CheckIcon />;
      default:
        return <ErrorIcon />;
    }
  };

  return (
    <Container>
      <ul>
        <>
          {steps.map((forms: number, key: number) => {
            return (
              <StepItem
                as={motion.li}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ delay: 0.5 }}
                // eslint-disable-next-line react/no-array-index-key
                key={key}
                selected={key < currentStep}
              >
                <div>{multIcons(forms)}</div>
                {key !== steps.length - 1 && <ArrowRight />}
              </StepItem>
            );
          })}
        </>
      </ul>
    </Container>
  );
};

export default Steps;
